module.exports = __webpack_public_path__ + "static/img/amigo_vi_login.f26f5b43.png";